import request from "@/utils/http";

export function login(username, password) {
  const data = { username: username, password: password };
  return request({
    url: "/api/ainvest_login/",
    method: "post",
    data,
  });
}
export function logout() {
  return request({
    url: "/api/ainvest_logout/",
    method: "post",
  });
}
export function bind_state(username) {
  const data = { username: username };
  return request({
    url: "/v3/bind_state",
    method: "post",
    data,
  });
}
/**
 * 检测当前会话是否处于登录检查
 */
// export function islogin() {
//   return request({
//     url: "/api/office_web/judge_login/",
//     method: "get",
//   });
// }

// /**
//  * 检测当前会话是否处于登录检查
//  */
// export function isloginV3() {
//   return request({
//     url: '/v3/judge_login',
//     method: 'get',
//   });
// }

/**
 * 检测当前会话是否处于登录检查
 */
export function islogin() {
  return request({
    url: "/v3/judge_login",
    method: "get",
    // 处理数据结构和原接口保持一致
  }).then((res) => ({
    ...res,
    login_status: res.data,
    status_code: res.code + "",
  }));
}
/**
 * 订阅选择投顾 需要改名subscribe
 * @param {String|Number} strategyid
 * @param {String|Number} classid
 */
export function choseStrategy(strategyid, classid) {
  const data = { new_strategy_id: strategyid, new_class_id: classid };
  return request({
    url: "/api/office_web/update_personal_strategy/",
    method: "post",
    data,
  });
}

/**
 * 切换自动交易启动状态
 * @param {String|Number} status_code
 */
export function toggleYidao(status_code) {
  const data = { status_code: status_code };
  return request({
    url: "/api/office_web/change_use/",
    method: "post",
    data,
  });
}

/**
 * 获取用户信息
 * @param {id:userid,token:token,username:username} data
 */
export function getUserInfofromNewServer(username) {
  const data = {
    username: username,
    nativeCode: "imAinvestcnabc",
    // phoneNumber: phoneNumber
  };
  return request({
    url: "/v3/getuserinfobn",
    method: "post",
    data,
  });
}
export function getUserInfofromOldServer(data) {
  return request({
    url: "/api/office_web/get_personal_info/",
    method: "get",
  });
}

export function customerReturnNew(username) {
  return request({
    url: `/v3/customer_return_new?u=${username}`,
    method: "get",
  });
}

/**
 * 获取投顾列表(排行榜)
 */
export function fetchStrategylist() {
  return request({
    url: "/api/office_web/get_list/",
    method: "get",
  });
}

/**
 * 获取投顾优选列表(排行榜)
 */
export function fetchGoodStrategylist(data) {
  return request({
    url: "/v3/recommend_strategies",
    method: "post",
    data: {},
  });
}

/**
 * 获取投顾优选列表(排行榜)-最新
 */
export function fetchGoodStrategylistV3(data) {
  return request({
    url: "/v3/v2/strategy/list",
    method: "get",
  });
}

/**
 * 获取全部投顾列表(排行榜)
 */
export function fetchAllStrategylist(data) {
  return request({
    url: "/v3/strategies",
    method: "post",
    data,
  });
}

/**
 * 获取 指定 投顾
 *
 */
export function fetchStrategy(sid, day, cid) {
  // https://www.ainvestcn.com/api/office_web/strategy_chart/?strategy_number=3&show_days=1&category_group=1
  const url =
    "/api/office_web/strategy_chart/?strategy_number=" +
    sid +
    "&show_days=" +
    day +
    "&category_group=" +
    cid;
  return request({
    url: url,
    method: "get",
  });
}

/**
 * 获取 指定 投顾 最新
 *
 */
export function fetchStrategyV2(sid, uid) {
  // https://www.ainvestcn.com/api/office_web/strategy_chart/?strategy_number=3&show_days=1&category_group=1
  const url = "/v3/v2/strategy/detail?strategy_id=" + sid + "&uid=" + uid;
  // const url = "/v3/v2/strategy/detail?strategy_id=" + sid + "&uid=18545841678";
  return request({
    url: url,
    method: "get",
  });
}

export function fetchTradeRecordInDetailV2(
  sid,
  uid,
  type,
  start_time,
  end_time
) {
  // const url = `/v3/v2/strategy/trade_history?strategy_id=${sid}&uid=${"18545841678"}&type=${type}&start_time=${start_time}&end_time=${end_time}&page_num=1`;
  const url = `/v3/v2/strategy/trade_history?strategy_id=${sid}&uid=${uid}&type=${type}&start_time=${start_time}&end_time=${end_time}&page_num=1`;
  return request({
    url,
    method: "get",
  });
}

export function fetchAccountTradeRecord(uid, type, start_time, end_time) {
  // const url = `/v3/v2/user/user_trade_history?uid=Rey&type=${type}&start_time=${start_time}&end_time=${end_time}&page_num=1`;
  const url = `/v3/v2/user/user_trade_history?uid=${uid}&type=${type}&start_time=${start_time}&end_time=${end_time}&page_num=1`;
  return request({
    url,
    method: "get",
  });
}

/**
 * 检测手机号是否占用
 * @param {String} phoneNumber
 */
export function usedphonenumber(phoneNumber) {
  const url = "/v3/usedphonenumber";
  const data = {
    nativeCode: "imAinvestcnabc",
    phoneNumber: phoneNumber,
  };
  return request({
    url: url,
    method: "post",
    data,
  });
}
/**
 * sms code
 * @param {*} phoneNumber
 */
export function getSmsCode(phoneNumber) {
  const url = "/v3/smscode";
  const data = {
    nativeKey: "imAinvestcnabc",
    phoneNumber: phoneNumber,
  };
  return request({
    url: url,
    method: "post",
    data,
  });
}
export function loginsmscode(phoneNumber) {
  const url = "/v3/loginsmscode";
  const data = {
    nativekey: "imAinvestcnabc",
    phonenumber: phoneNumber,
  };
  return request({
    url: url,
    method: "post",
    data,
  });
}
/**
 * 检查验证码
 * @param {String} phoneNumber 手机号
 * @param {String} smscode 验证码
 */
export function ckSmsCode(phoneNumber, smscode) {
  const url = "/v3/verifysmscode";
  const data = {
    nativeCode: "imAinvestcnabc",
    phoneNumber: phoneNumber,
    smsCode: smscode,
  };
  return request({
    url: url,
    method: "post",
    data,
  });
}
/**
 * 用户注册接口
 * @param {
 *  nativeCode:String,
 *  username:String,
 *  phoneNumber:String
 * } data
 */
export function register(data) {
  const url = "/v3/register";
  return request({
    url: url,
    method: "post",
    data,
  });
}

/**
 * 快速注册接口
 * @param {
 *  nativeCode:String,
 *  phone:String,
 *  code:String,
 *  ua:String,
 *  ip:String
 * } data
 */
export function fastReg(data) {
  const url = "/v3/register";
  return request({
    url: url,
    method: "post",
    data,
  });
}

/**
 * 申请星火
 * @param {
 *  nativeCode:String,
 *  username:String,
 *  phoneNumber:String
 * } data
 */
export function applyYidao(data) {
  const url = "/v3/applyyidao";
  return request({
    url: url,
    method: "post",
    data,
  });
}

/**
 * 获取券商列表
 */
export function fetchSecurities() {
  const url = "/v3/securities";
  return request({
    url: url,
    method: "get",
  });
}

/**
 * 获取历史持仓
 */
export function fetchHistory(sid, cid) {
  const url =
    "/api/office_web/new_transaction_record/?strategy_number=" +
    sid +
    "&category_group=" +
    cid;
  return request({
    url: url,
    method: "get",
  });
}
/**
 * 获取历史持仓
 */
export function fetchHistoryWithDate(sid, cid, date) {
  const url =
    "/api/office_web/new_transaction_record/?strategy_number=" +
    sid +
    "&category_group=" +
    cid +
    "&date=" +
    date;
  return request({
    url: url,
    method: "get",
  });
}
/**
 * 获取调仓记录
 */
export function fetchWarehouseHistory(sid, cid) {
  // https://www.ainvestcn.com/api/office_web/adjust_record/?strategy_number=3&category_group=1
  const url =
    "/api/office_web/adjust_record/?strategy_number=" +
    sid +
    "&category_group=" +
    cid;
  return request({
    url: url,
    method: "get",
  });
}
/**
 *
 * @param {*} sid
 * @param {*} cid
 * @param {*} date
 */
export function fetchWarehouseHistoryWithDate(sid, cid, date) {
  // https://www.ainvestcn.com/api/office_web/adjust_record/?strategy_number=3&category_group=1
  const url =
    "/api/office_web/adjust_record/?strategy_number=" +
    sid +
    "&category_group=" +
    cid +
    "&date=" +
    date;
  return request({
    url: url,
    method: "get",
  });
}

/**
 * 申请模拟账号
 */
export function fetchdemoAccount() {
  return request({
    url: "/api/office_web/get_demo_account/",
    method: "get",
  });
}
/**
 *
 */
// 历史持仓
export function fetchTradeRecord() {
  return request({
    url: "/api/office_web/personal_transaction_record/",
    method: "get",
  });
}
// 历史交易
export function fetchAdjustRecord() {
  return request({
    url: "/api/office_web/new_personal_adjust_record/",
    method: "get",
  });
}
// 历史持仓日期查询
export function fetchTradeRecordWithDate(date) {
  return request({
    url: "/api/office_web/personal_transaction_record/?date=" + date,
    method: "get",
  });
}
// 历史交易日期查询
export function fetchAdjustRecordWithDate(date) {
  return request({
    url: "/api/office_web/new_personal_adjust_record/?date=" + date,
    method: "get",
  });
}

export function evtlogadd(evnt, ua, ip, page) {
  const data = {
    phone: "",
    event: evnt,
    ua: ua,
    ipv4: ip,
    page: page,
  };
  return request({
    url: "/v3/addEvtlog",
    method: "post",
    data,
  });
}

export function evtlogadd2(evnt, phone, ua, ip) {}
/**
 * 提交订单检查
 * @param {*} ordernum
 * @param {*} username
 * @param {*} agent
 */
export function addcheck(ordernum, username, agent) {
  const url = "/v3/addcheck";
  const data = {
    nativeCode: "imAinvestcnabc",
    number: ordernum,
    username: username,
    agent: agent,
  };
  return request({
    url: url,
    method: "post",
    data: data,
  });
}
export function isPayTime(username) {
  const url = "/v3/paid";
  const data = {
    nativeCode: "imAinvestcnabc",
    username: username,
  };
  return request({
    url: url,
    method: "post",
    data: data,
  });
}
export function regtime() {
  const url = "api/office_web/registration_time";
  return request({
    url: url,
    method: "get",
  });
}

export function isvipApi(username) {
  const data = {
    nativeCode: "imAinvestcnabc",
    username: username,
  };
  return request({
    url: "/v3/isvip",
    method: "post",
    data,
  });
}
// reg/autoApplymn
export function autoApplymn(sessionid) {
  const data = {
    nativeCode: "imAinvestcnabc",
  };
  return request({
    url: "/v3/autoApplyMon1",
    method: "post",
    data,
  });
}
export function loginv2(phone, code) {
  const data = {
    phone_number: phone,
    verify_code: code,
  };
  return request({
    url: "/api/ainvest_login_new/",
    method: "post",
    data,
  });
}
export function paylog(phone, invitationCode) {
  const data = {
    nativeCode: "nativeCode",
    phone: phone,
    invitationCode: invitationCode,
  };
  return request({
    url: "/v3/paylog",
    method: "post",
    data,
  });
}

export function agentApply(phoneNumber, fullname, inviteByCode) {
  const data = {
    fullname: fullname,
    phoneNumber: phoneNumber,
    inviteByCode: inviteByCode,
  };
  return request({
    url: "/v3/agent/apply",
    method: "post",
    data,
  });
}

/**
 * 切换锁定开关,设置切换比例， 又写一起了，哈哈哈， 留坑
 * @param {string} phone 手机号
 */
export function toggleLockMoney(phone, lockpercent) {
  const data = {
    phone: phone,
    lockpercent: lockpercent,
    nativeCode: "imAinvestcnabc",
  };
  return request({
    url: "/v3/togglelockmoney",
    method: "post",
    data: data,
  });
}

/**
 * 历史记录
 * @param {string} username 手机号
 */
export function history_adjusts(username) {
  const data = {
    username: username,
  };
  return request({
    url: "/v3/history_adjusts",
    method: "post",
    data: data,
  });
}

/**
 * 支付
 * @param {string} username
 * @param {Boolean} isMoble
 * @param {string} alipay
 * @param {string} couponCode
 */
export function pay_vip(data) {
  return request({
    url:
      "/v3/pay_vip?platform=" +
      data.platform +
      "&isMobile=" +
      data.isMobile +
      "&username=" +
      data.username +
      "&couponCode=" +
      data.couponCode +
      "&openId=" +
      data.openId,
    method: "get",
  });
}

export function pay_vip2(data) {
  return request({
    url:
      "/v3/pay_vip2?platform=" +
      data.platform +
      "&isMobile=" +
      data.isMobile +
      "&username=" +
      data.username +
      "&couponCode=" +
      data.couponCode +
      "&openId=" +
      data.openId,
    method: "get",
  });
}

export function pay_point(data) {
  return request({
    url: "/v3/pay?platform=" + data.platform + "&price=" + data.price,
    method: "get",
  });
}

/**
 * 拿到微信openid
 * @param {string} username
 * @param {Boolean} isMoble
 * @param {string} alipay
 * @param {string} couponCode
 */
export function getWeOpenId(data) {
  return request({
    url: `/v3/wx_openid?code=${data.code}&agentId=${data.agentId}`,
    method: "get",
  });
}

/**
 * 拿到微信openid
 * @param {string} username
 * @param {Boolean} isMoble
 * @param {string} alipay
 * @param {string} couponCode
 */
export function bindInviteCode(data) {
  return request({
    url: "/v3/bind_invite_code",
    method: "post",
    data: data,
  });
}

/**
 * VIP兑换码兑换
 * @param {String} username 用户名
 * @param {String} code 兑换码
 */
export function exchangeVipCode(username, code) {
  const data = {
    username: username,
    code: code,
    nativeCode: "imAinvestcnabc",
  };
  return request({
    url: "/v3/exchange_vip",
    method: "post",
    data,
  });
}

/**
 * 申请云主机
 * @param {string} username - 用户名
 * @returns {Promise} 返回申请结果
 */
export function applyCloudServer(username) {
  return request({
    url: "/v3/cloud/apply",
    method: "post",
    data: {
      username,
      nativeCode: "imAinvestcnabc",
    },
  });
}

/**
 * 获取云主机状态
 * @param {string} username - 用户名
 * @returns {Promise} 返回云主机信息
 */
export function getCloudServerStatus(username) {
  return request({
    url: `/v3/cloud/status?username=${username}&nativeCode=imAinvestcnabc`,
    method: "get",
  });
}

/**
 * 测试Python代码
 * @param {Object} data - 请求数据
 * @param {string} data.username - 用户名
 * @param {string} data.code - Python代码内容
 * @returns {Promise} 返回测试结果
 */
export function testPythonCode(data) {
  return request({
    url: "/v3/cloud/test",
    method: "post",
    data: {
      ...data,
      nativeCode: "imAinvestcnabc",
    },
  });
}

/**
 * 部署Python代码
 * @param {Object} data - 请求数据
 * @param {string} data.username - 用户名
 * @param {string} data.code - Python代码内容
 * @param {string} data.cloudServerId - 云主机ID
 * @returns {Promise} 返回部署结果
 */
export function deployPythonCode(data) {
  return request({
    url: "/v3/cloud/deploy",
    method: "post",
    data: {
      ...data,
      nativeCode: "imAinvestcnabc",
    },
  });
}

/**
 * 关闭云主机
 * @param {string} username - 用户名
 * @returns {Promise} 返回关机操作结果
 */
export function shutdownCloudServer(username) {
  return request({
    url: "/v3/cloud/shutdown",
    method: "post",
    data: {
      username,
      nativeCode: "imAinvestcnabc",
    },
  });
}

/**
 * 开启云主机
 * @param {string} username - 用户名
 * @returns {Promise} 返回开机操作结果
 */
export function startupCloudServer(username) {
  return request({
    url: "/v3/cloud/startup",
    method: "post",
    data: {
      username,
      nativeCode: "imAinvestcnabc",
    },
  });
}

/**
 * 充值记录查询
 * @param {string} username - 用户名
 * @returns {Promise} 返回充值记录
 */
export function fetchRechargeRecord(username) {
  const url = `/v3/v2/user/balance_record?uid=${username}`;
  return request({
    url,
    method: "get",
  });
}

/**
 * 余额中心
 * @param {string} username - 用户名
 * @returns {Promise} 返回可选套餐
 */
export function fetchBalanceCenter(username) {
  const url = `/v3/v2/user/balance_center?uid=${username}`;
  // const url = `/v3/v2/user/balance_center?uid=18545841678`;
  return request({
    url,
    method: "get",
  });
}

/**
 * @param {string} uid - 用户名
 * @param {string} planId - 兑换id
 */
export function fetchServerTime(uid, planId) {
  const url = `/v3/v2/user/buy_server_time?planId=${planId}&uid=${uid}`;
  return request({
    url,
    method: "get",
  });
}

/**
 * @param {string} uid - 用户名
 */
export function fetchUserReturnInfo(uid) {
  const url = `/v3/v2/user/user_position_info?uid=${uid}`;
  return request({
    url,
    method: "get",
  });
}

export function checkUserIndentity(uid) {
  const url = `/v3/v2/user/check_real_name_auth?uid=${uid}`;
  return request({
    url,
    method: "get",
  });
}

export function setUserIndentity(data) {
  const url = `/v3/v2/user/set_real_name_auth`;
  return request({
    url,
    method: "post",
    data,
  });
}

/**
 * @param {string} uid - 用户名
 */
export function fetchUserIndentity(uid) {
  const url = `/v3/v2/user/user_info?uid=${uid}`;
  return request({
    url,
    method: "get",
  });
}

// 增加用户券商配置
export function setUserSecuritiesInfo(data) {
  const url = `/v3/v2/user/set_securities_setting`;
  return request({
    url,
    method: "post",
    data,
  });
}
/**
 * @param {string} uid - 用户名
 * @param {string} strategyId - 策略id
 */
export function fetchUserSubscribeStrategy(uid, strategyId) {
  const url = `/v3/v2/user/subscribe_strategy`;
  return request({
    url,
    method: "post",
    data: {
      strategyId,
      uid,
    },
  });
}

/**
 * 生成代码
 * @param {string} uid - 用户名
 */
export function genCode(uid) {
  const url = `/v3/cloud/gen?uid=${uid}`;
  return request({
    url,
    method: "get",
  });
}

/**
 * 创建新的通话会话
 * @param {Object} callData - 通话会话数据
 * @returns {Promise} 返回创建结果
 */
export function createCall(title = "语音通话", chatId = "") {
  return request({
    url: `/v3/chat/create?title=${title}&chatId=${chatId}`,
    method: "post",
  });
}

// 获取用户的通话历史列表
export function getCallList() {
  return request({
    url: "/v3/chat/list",
    method: "get",
  });
}

// 获取特定通话的记录历史
export function getCallTranscripts(chatId) {
  return request({
    url: `/v3/chat/messages?chatId=${chatId}`,
    method: "get",
  });
}

/**
 * 添加通话记录（语音识别和AI回复）
 * @param {*} data {
    "chatId":37,
    "seq":2,
    "msgType":"answer", // question问/answer回答
    "content":"我是回答"
}
 * @returns 
 */

export const addTranscript = async (data) => {
  return request({
    url: ` /v3/chat/message/new`,
    method: "post",
    data,
  });
};

// 获取通话总结
export const getCallSummary = async (callId, history, oldSummary) => {
  return request({
    url: `/call/${callId}/summary`,
    method: "post",
    data: {
      history: history, // 修改为后端期望的格式
      old_summary: oldSummary,
    },
  });
};
// 历史对话列表
export function getIndexData(params) {
  return request({
    // url: `/v3/chat/list?uid=${params.uid}&pageIndex=${params.pageIndex}%pageSize=${params.pageSize}`,
    url: `/v3/chat/list`,
    method: "get",
    params,
  });
}

// 对话详情
export function getIndexDataDetail(chatId) {
  return request({
    url: `/v3/chat/messages?chatId=${chatId}`,
    method: "get",
  });
}

// 提问
export function questionsAndAnswers(params) {
  return request({
    url: `/v3/chat/submit`,
    method: "get",
    params,
  });
}

// 新个人页用户信息接口
export function userInfoDetail(uid) {
  return request({
    url: `/v3/v2/user/user_detail?uid=${uid}`,
    method: "get",
  });
}

/**
 * 更新用户签约状态
 * @param {string} uid - 用户名
 * @returns {Promise} 返回更新结果
 */
export function updateUserSignStatus(uid, type) {
  return request({
    url: `/v3/v2/user/update_user_sign_status?uid=${uid}&type=${type}`,
    method: "get",
  });
}

/**
 * 更新用户访问状态
 * @param {string} uid - 用户名
 * @returns {Promise} 返回更新结果
 */
export function updateUserVisitStatus(params) {
  const { uid, type } = params;
  return request({
    url: `/v3/v2/user/update_user_visit_status?uid=${uid}&type=${type}`,
    method: "get",
  });
}

export function getOrderInfo(orderId) {
  return request({
    url: `/v3/order/status?orderId=${orderId}`,
    method: "get",
  });
}

// 合伙人
export function partnershipInfo(uid) {
  return request({
    url: `/v3/v2/user/partner_info?uid=${uid}`,
    method: "get",
  });
}

/**
 * 获取实名认证页面地址
 */
export function getRealNameAuthUrl(uid) {
  return request({
    url: `/v3/v2/user/detect_url?uid=${uid}&redirect_url=${encodeURIComponent(
      window.location.href
    )}`,
    method: "get",
  });
}

/**
 * 查询实名认证结果
 */
export function getRealNameAuthResult(uid, biz_token) {
  return request({
    url: `/v3/v2/user/get_detect_res?uid=${uid}&biz_token=${biz_token}`,
    method: "get",
  });
}
